/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Explore_Top_Rated_DetailInputs */

const en_common_header_explore_top_rated_detail = /** @type {(inputs: Common_Header_Explore_Top_Rated_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Highest-rated products`)
};

const zh_common_header_explore_top_rated_detail = /** @type {(inputs: Common_Header_Explore_Top_Rated_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`评分最高的产品`)
};

/**
* | output |
* | --- |
* | "Highest-rated products" |
*
* @param {Common_Header_Explore_Top_Rated_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_explore_top_rated_detail = /** @type {((inputs?: Common_Header_Explore_Top_Rated_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Explore_Top_Rated_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_explore_top_rated_detail(inputs)
	return zh_common_header_explore_top_rated_detail(inputs)
});
export { common_header_explore_top_rated_detail as "common.header.explore.top_rated.detail" }